<div class="title-container">
  <span>{{ title() }}</span>
  @if (status(); as status) {
    <div class="badge-container">
      <glxy-badge [color]="statusColor()">{{ status | translate }}</glxy-badge>
    </div>
  }
</div>
